import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'root/view/base';

export default View.extend({
    className: 'box-medium box-integration',

    events: {
        'click .download': 'download'
    },

    dom_handlers: {
        download: function() {
            if (Cache.account.hasFeature('intercom')) {
                window.open('https://www.intercom.com/app-store?app_package_code=userback-18fu', '_blank', 'noopener');
            } else {
                Modals.unlockFeature();
            }
        },
    },

    render: function() {
        var content =
        '<div class="thumbnail">' +
            '<img src="/image/intercom_small.png">' +
        '</div>' +
        '<div class="content">' +
            '<h3>Intercom</h3>' +
            '<div>Add Userback to Intercom Messenger and Outbound Bots.</div>' +
        '</div>' +
        '<div class="action">' +
            '<button type="button" class="tertiary small min download">Install</button>' +
        '</div>';

        this.$el.html(content);

        return this;
    }
});